'use strict';

var RESULT_ANY = {title: bbw.messages.any_location};

var LocationPickerModalController = ngtk.controller.Base.extend({

    $inject: ['$scope', '$q', 'bbw.GeoLocationRepository', '$timeout'],

    /**
     * @type {bbw.service.GeoLocationRepository}
     */
    _bbwGeoLocationRepository: undefined,

    _init: function() {
        this.$scope.selectionMode = 'country';
        this.$scope.selection = {};

        this.$scope.select = function(location) {
            switch (this.$scope.selectionMode) {
                case 'country':
                    this.selectCountry(location);
                    break;
                case 'region':
                    this.selectRegion(location);
                    break;
                case 'city':
                    this.selectCity(location);
                    break;
            }
        }.bind(this);

        this.$scope.back = function() {
            if (this.$scope.loading) {
                return;
            }
            switch (this.$scope.selectionMode) {
                case 'country':
                    this.submit(undefined);
                    break;
                case 'region':
                    this.$scope.selectionMode = 'country';
                    this._load();
                    break;
                case 'city':
                    this.$scope.selectionMode = 'region';
                    this._load();
                    break;
            }
        }.bind(this);

        this.$scope.cancel = function() {
            this.$scope.loading || submit(undefined);
        }.bind(this);

        var initPromise;
        if (angular.isObject(this.$scope.initialValue)) {
            switch (this.$scope.initialValue.type) {
                case 'city':
                    initPromise = this._loadAndSelectCountryAndRegionById(
                        this.$scope.initialValue.country_id,
                        this.$scope.initialValue.region_id
                    );
                    break;
                case 'region':
                    initPromise = this._loadAndSelectCountryById(
                        this.$scope.initialValue.country_id,
                        this.$scope.initialValue.region_id
                    );
                    break;
            }
        }

        if (initPromise) {
            return initPromise.catch(function() {
                this.$scope.initialValue = undefined;
                this.$scope.selectionMode = 'country';
                this.$scope.selection = {};
                return this._load();
            }.bind(this));
        } else {
            return this._load();
        }
    },

    _loadAndSelectCountryById: function(countryId) {
        this.$scope.selectionMode = 'country';
        return this._load().then(function() {
            var country = this.$scope.locations.find(function(candidate) {
                return candidate.country_id == countryId;
            });
            if (!country) {
                return this.$q.reject();
            }
            return this.selectCountry(country);
        }.bind(this));
    },

    _loadAndSelectCountryAndRegionById: function(countryId, regionId) {
        return this._loadAndSelectCountryById(countryId).then(function() {
            if (this.$scope.selectionMode !== 'region') {
                throw new Error("Internal error: unexpected selectionMode state");
            }
            var region = this.$scope.locations.find(function(candidate) {
                return candidate.region_id == regionId;
            });
            if (!region) {
                return this.$q.reject();
            }
            return this.selectRegion(region);
        }.bind(this));
    },

    _load: function() {
        var loadPromise;
        var selection = this.$scope.selection;
        switch (this.$scope.selectionMode) {
            case 'country':
                loadPromise = this._bbwGeoLocationRepository.getCountries();
                break;
            case 'region':
                loadPromise = this._bbwGeoLocationRepository.getRegions(selection.country.country_id);
                break;
            case 'city':
                loadPromise = this._bbwGeoLocationRepository.getCities(selection.region.region_id);
                break;
        }
        this.$scope.loading = true;
        return loadPromise
            .then(function(response) {
                this.$scope.locations = response;
                selection[this.$scope.selectionMode] = undefined;
            }.bind(this))
            .finally(function() {
                this.$scope.loading = false;
                this.$scope.ready = true;
                loadPromise = undefined;
            }.bind(this));
    },

    selectCountry: function(country) {
        if (!country) {
            return this.submit(RESULT_ANY);
        }
        this.$scope.selection.country = country;
        this.$scope.selectionMode = 'region';
        return this._load();
    },

    selectRegion: function(region) {
        if (!region) {
            return this.submit(this.$scope.selection.country);
        }
        this.$scope.selection.region = region;
        this.$scope.selectionMode = 'city';
        return this._load();
    },

    selectCity: function(city) {
        this.submit(city ? city : this.$scope.selection.region);
    },

    submit: function(result) {
        this.$scope.$modal.close();
        this.$scope.submit(result);
    }

});

var LocationPickerController = ngtk.controller.Base.extend({

    $inject: ['$scope', '$q', 'bbw.GeoLocationRepository', '$fancyModal', '$timeout', 'bbw.LayoutTypeSvc'],

    /**
     * @type {bbw.service.GeoLocationRepository}
     */
    _bbwGeoLocationRepository: undefined,

    DEFAULT_LIMIT: 5,

    placeholder: undefined,
    choices: undefined,
    loading: true,
    searching: false,
    notFound: false,
    autodetectedChoice: undefined,
    defaultChoice: undefined,
    defaultChoices: undefined,
    isMobile: false,
    isMobilePickerOpened: false,
    mobileTitle: undefined,

    _init: function() {
        this.value = {};
        this.$scope.refresh = this.findBySubstring.bind(this);
        this.$scope.onSelect = this.onValueSelected.bind(this);
        this.isMobile = this._bbwLayoutTypeSvc.isMobile();
    },

    $onInit: function() {
        this.limit = this.limit || this.DEFAULT_LIMIT;
        this.choices = [];
        this.value = angular.isObject(this.initialValue) ? angular.copy(this.initialValue) : undefined;
        var loadingPromise;
        if (this.autodetect) {
            loadingPromise = this._bbwGeoLocationRepository.findCityByGeoIp().then(function(value) {
                this.autodetectedChoice = value;
            }.bind(this));
        } else {
            loadingPromise = this.$q.when();
        }
        loadingPromise.then(function() {
            this.defaultChoices = [];
            if (this.autodetectedChoice) {
                this.defaultChoices.push(this.autodetectedChoice);
            }
            if (this.defaultList && angular.isArray(this.defaultList)) {
                this.defaultChoices.push.apply(this.defaultChoices, this.defaultList);
            } else if (this.defaultChoice) {
                this.defaultChoices.push(this.defaultChoice);
            }
            this.placeholder || this._setPlaceholderHint(this.defaultChoices[0]);
            if (!this.mobileTitle) {
                this.mobileTitle = this.cityOnly ? bbw.messages.select_city : bbw.messages.select_location;
            }
            if (this.defaultValue) {
                this._selectValue(this.defaultValue);
            }
        }.bind(this)).finally(function() {
            this.loading = false;
            this.ready = true;
        }.bind(this));
    },

    _setPlaceholderHint: function(location) {
        this.placeholder = bbw.messages.example + (location && location.name ? location.name : bbw.messages.city_example);
    },

    openMobilePicker: function() {
        this.isMobilePickerOpened = true;
        this.focusMobilePicker();
    },

    focusMobilePicker: function () {
        this.$timeout(function() {
            this.$select.focusSearchInput();
            this.$timeout(function() {
                this.$select.activate();
            }.bind(this), 50);
        }.bind(this), 50);
    },

    closeMobilePicker: function() {
        this.isMobilePickerOpened = false;
    },

    findBySubstring: function(substring) {
        var responsePromise;
        this.notFound = false;
        if (substring.trim().length) {
            this.searching = true;
            if (this.cityOnly) {
                responsePromise = this._bbwGeoLocationRepository.findCitiesBySubstring(substring, this.limit);
            } else {
                responsePromise = this._bbwGeoLocationRepository.findLocationsBySubstring(substring, this.limit);
            }
        } else {
            responsePromise = this.$q.when(undefined);
        }
        responsePromise.finally(function() {
            this.searching = false;
        }.bind(this));
        return responsePromise.then(function(choices) {
            this.choices = choices || this.defaultChoices;
            this.notFound = !this.choices.length && angular.isDefined(choices);
        }.bind(this));
    },

    onValueSelected: function(value) {
        angular.isFunction(this.onUpdate) && this.onUpdate({value: angular.copy(value)});
        if (this.isMobilePickerOpened) {
            this.closeMobilePicker();
        }
    },

    selectFromList: function() {
        this._openModal();
    },

    _openModal: function() {
        var scope = this.$scope.$new();
        scope.allowAny = !this.cityOnly;
        scope.initialValue = angular.copy(this.value);
        scope.submit = this._submitModal.bind(this);
        this.$fancyModal.open({
            scope: scope,
            themeClass: 'location-modal-container',
            templateUrl: bbw.templateUrl('components/location-picker.modal.html'),
            controller: LocationPickerModalController
        });
    },

    _submitModal: function(result) {
        if (angular.isDefined(result)) {
            if (angular.isObject(result)) {
                result = angular.copy(result);
            }
            this.$select.search = '';
            this.$select.items = [result];
            this.$select.select(result);
        } else {
            if (this.isMobilePickerOpened) {
                this.focusMobilePicker();
            }
        }
    },

    _selectValue: function(result) {
        this.$timeout(function() {
            this.$select.search = '';
            this.$select.items = [result];
            this.$select.select(result);
        }.bind(this));
    }

});

bbw.LocationPickerComponent = {
    templateUrl: bbw.templateUrl('components/location-picker.component.html'),
    controller: LocationPickerController,
    bindings: {
        autodetect: '<',
        addClass: '<',
        placeholder: '<',
        defaultChoice: '<',
        defaultList: '<',
        defaultValue: '<',
        cityOnly: '<',
        mobileTitle: '<',
        limit: '<',
        onUpdate: '&'
    }
};
